import { render, staticRenderFns } from "./InitAdvertiser.vue?vue&type=template&id=d8749cc8&scoped=true"
import script from "./InitAdvertiser.vue?vue&type=script&lang=js"
export * from "./InitAdvertiser.vue?vue&type=script&lang=js"
import style0 from "./InitAdvertiser.vue?vue&type=style&index=0&id=d8749cc8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8749cc8",
  null
  
)

export default component.exports